import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.changeImpacts',
    'resource:data.dimensions.changeImpacts.entities.changeImpact',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.areaOfConcern',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.anticipatedResponseOfChange',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.communicationsNeeded',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.communicationsNotes',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.currentState',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.degreeOfChange',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.engagementsNeeded',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.functionalArea',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.futureState',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.impactedGroups',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.keyBenefit',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.otherComments',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.phase',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.priority',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.sprint',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.status',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.subtopicOne',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.subtopicTwo',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.system',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.targetGoLiveDate',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.topic',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.trainingImplications',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.trainingImplicationsNotes',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.type',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.userStory',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.validationStatus',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.valueOfChange',
    'resource:data.enums.changeImpactAnticipatedResponse',
    'resource:data.enums.changeImpactAnticipatedResponse.entries.mixed',
    'resource:data.enums.changeImpactAnticipatedResponse.entries.negative',
    'resource:data.enums.changeImpactAnticipatedResponse.entries.neutral',
    'resource:data.enums.changeImpactAnticipatedResponse.entries.positive',
    'resource:data.enums.changeImpactAnticipatedResponse.entries.unknown',
    'resource:data.enums.changeImpactDepartment',
    'resource:data.enums.changeImpactDepartment.entries.advancementCommunicationsMarketing',
    'resource:data.enums.changeImpactDepartment.entries.advancementOperations',
    'resource:data.enums.changeImpactDepartment.entries.advancementStudies',
    'resource:data.enums.changeImpactDepartment.entries.alumniEngagement',
    'resource:data.enums.changeImpactDepartment.entries.alumniRelations',
    'resource:data.enums.changeImpactDepartment.entries.annualGiving',
    'resource:data.enums.changeImpactDepartment.entries.campaignOperations',
    'resource:data.enums.changeImpactDepartment.entries.corporateResources',
    'resource:data.enums.changeImpactDepartment.entries.development',
    'resource:data.enums.changeImpactDepartment.entries.developmentFundraising',
    'resource:data.enums.changeImpactDepartment.entries.donorRelationsAndStewardship',
    'resource:data.enums.changeImpactDepartment.entries.foundationRelations',
    'resource:data.enums.changeImpactDepartment.entries.majorGifts',
    'resource:data.enums.changeImpactDepartment.entries.planningGiving',
    'resource:data.enums.changeImpactDepartment.entries.principalGifts',
    'resource:data.enums.changeImpactDepartment.entries.prospectDevelopment',
    'resource:data.enums.changeImpactFunctionalArea',
    'resource:data.enums.changeImpactFunctionalArea.entries.buildFunctional',
    'resource:data.enums.changeImpactFunctionalArea.entries.changeManagement',
    'resource:data.enums.changeImpactFunctionalArea.entries.dataIntegration',
    'resource:data.enums.changeImpactFunctionalArea.entries.dataMigration',
    'resource:data.enums.changeImpactFunctionalArea.entries.marketingCloud',
    'resource:data.enums.changeImpactFunctionalArea.entries.projectManagement',
    'resource:data.enums.changeImpactFunctionalArea.entries.reportingAndAnalytics',
    'resource:data.enums.changeImpactFunctionalArea.entries.technical',
    'resource:data.enums.changeImpactPhase',
    'resource:data.enums.changeImpactPhase.entries.backlog',
    'resource:data.enums.changeImpactPhase.entries.bioDemo',
    'resource:data.enums.changeImpactPhase.entries.design',
    'resource:data.enums.changeImpactPhase.entries.discovery',
    'resource:data.enums.changeImpactPhase.entries.giftsAndPledges',
    'resource:data.enums.changeImpactPhase.entries.givingSocieties',
    'resource:data.enums.changeImpactPhase.entries.memberships',
    'resource:data.enums.changeImpactPhase.entries.prospectResearchAndManagement',
    'resource:data.enums.changeImpactPhase.entries.stewardship',
    'resource:data.enums.changeImpactPhase.entries.testing',
    'resource:data.enums.changeImpactPhase.entries.training',
    'resource:data.enums.changeImpactRank',
    'resource:data.enums.changeImpactRank.entries.high',
    'resource:data.enums.changeImpactRank.entries.medium',
    'resource:data.enums.changeImpactRank.entries.low',
    'resource:data.enums.changeImpactSprint',
    'resource:data.enums.changeImpactSprint.entries.backlog',
    'resource:data.enums.changeImpactSprint.entries.design',
    'resource:data.enums.changeImpactSprint.entries.discovery',
    'resource:data.enums.changeImpactSprint.entries.sprint1',
    'resource:data.enums.changeImpactSprint.entries.sprint2',
    'resource:data.enums.changeImpactSprint.entries.sprint3',
    'resource:data.enums.changeImpactSprint.entries.sprint4',
    'resource:data.enums.changeImpactSprint.entries.sprint5',
    'resource:data.enums.changeImpactSprint.entries.sprint6',
    'resource:data.enums.changeImpactSprint.entries.sprint7',
    'resource:data.enums.changeImpactSprint.entries.sprint8',
    'resource:data.enums.changeImpactSprint.entries.sprint9',
    'resource:data.enums.changeImpactSprint.entries.sprint10',
    'resource:data.enums.changeImpactSprint.entries.sprint11',
    'resource:data.enums.changeImpactSprint.entries.sprint12',
    'resource:data.enums.changeImpactSprint.entries.sprint13',
    'resource:data.enums.changeImpactSprint.entries.sprint14',
    'resource:data.enums.changeImpactSprint.entries.testing',
    'resource:data.enums.changeImpactSprint.entries.training',
    'resource:data.enums.changeImpactStatus',
    'resource:data.enums.changeImpactStatus.entries.complete',
    'resource:data.enums.changeImpactStatus.entries.inProgress',
    'resource:data.enums.changeImpactStatus.entries.inReview',
    'resource:data.enums.changeImpactStatus.entries.notStarted',
    'resource:data.enums.changeImpactType',
    'resource:data.enums.changeImpactType.entries.cultural',
    'resource:data.enums.changeImpactType.entries.data',
    'resource:data.enums.changeImpactType.entries.feature',
    'resource:data.enums.changeImpactType.entries.field',
    'resource:data.enums.changeImpactType.entries.policy',
    'resource:data.enums.changeImpactType.entries.process',
    'resource:data.enums.changeImpactType.entries.reporting',
    'resource:data.enums.changeImpactType.entries.responsibilities',
    'resource:data.enums.changeImpactType.entries.roles',
    'resource:data.enums.changeImpactType.entries.security',
    'resource:data.enums.changeImpactType.entries.terminology',
    'resource:data.enums.changeImpactValidationStatus',
    'resource:data.enums.changeImpactValidationStatus.entries.completed',
    'resource:data.enums.changeImpactValidationStatus.entries.inProgress',
    'resource:data.enums.changeImpactValidationStatus.entries.notStarted',
    'resource:data.enums.changeImpactYesNoNa',
    'resource:data.enums.changeImpactYesNoNa.entries.na',
    'resource:data.enums.changeImpactYesNoNa.entries.no',
    'resource:data.enums.changeImpactYesNoNa.entries.yes',
    'resource:solutions.apps.changeImpacts',
    'resource:solutions.apps.changeImpacts.pages.changeImpactLog',
    'resource:solutions.apps.changeImpacts.pages.dashboard',
    'resource:solutions.apps.changeImpacts.pages.details',
    'resource:solutions.apps.changeImpacts.pages.changeImpacts',
    'resource:solutions.mosaic.actions.changeImpacts.saveChangeImpact',
    'resource:solutions.mosaic.pages.changeImpacts.changeImpactLog',
    'resource:solutions.mosaic.pages.changeImpacts.dashboard',
    'resource:solutions.mosaic.pages.changeImpacts.details',
    'resource:solutions.mosaic.pages.changeImpacts.changeImpacts',
    'resource:solutions.mosaic.widgets.changeImpacts.anticipatedResponseOfChange',
    'resource:solutions.mosaic.widgets.changeImpacts.anticipatedResponseOfChangeByDepartment',
    'resource:solutions.mosaic.widgets.changeImpacts.anticipatedResponseOfChangeByFunctionalArea',
    'resource:solutions.mosaic.widgets.changeImpacts.areaOfConcernByFunctionalArea',
    'resource:solutions.mosaic.widgets.changeImpacts.changeImpactDetails',
    'resource:solutions.mosaic.widgets.changeImpacts.changeImpactLog',
    'resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByDepartment',
    'resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByEpic',
    'resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByEpicAndFunctionalArea',
    'resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByStatus',
    'resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByValidationStatus',
    'resource:solutions.mosaic.widgets.changeImpacts.changeImpactsTable',
    'resource:solutions.mosaic.widgets.changeImpacts.communicationsNeededByDepartment',
    'resource:solutions.mosaic.widgets.changeImpacts.communicationsNeededByFunctionalArea',
    'resource:solutions.mosaic.widgets.changeImpacts.createChangeImpactModal',
    'resource:solutions.mosaic.widgets.changeImpacts.degreeAndValueOfChangeTable',
    'resource:solutions.mosaic.widgets.changeImpacts.degreeOfChangeBarChart',
    'resource:solutions.mosaic.widgets.changeImpacts.degreeOfChangeByDepartment',
    'resource:solutions.mosaic.widgets.changeImpacts.degreeOfChangeByEpic',
    'resource:solutions.mosaic.widgets.changeImpacts.degreeOfChangeByFunctionalArea',
    'resource:solutions.mosaic.widgets.changeImpacts.editChangeImpactModal',
    'resource:solutions.mosaic.widgets.changeImpacts.functionalAreaBarChart',
    'resource:solutions.mosaic.widgets.changeImpacts.highRiskTable',
    'resource:solutions.mosaic.widgets.changeImpacts.keyBenefitsByFunctionalArea',
    'resource:solutions.mosaic.widgets.changeImpacts.outstandingImpactsByPriority',
    'resource:solutions.mosaic.widgets.changeImpacts.overviewReportCard',
    'resource:solutions.mosaic.widgets.changeImpacts.phaseBarChart',
    'resource:solutions.mosaic.widgets.changeImpacts.trainingImplicationsByDepartment',
    'resource:solutions.mosaic.widgets.changeImpacts.trainingImplicationsByFunctionalArea',
    'resource:solutions.mosaic.widgets.changeImpacts.typeBarChart',
    'resource:solutions.mosaic.widgets.changeImpacts.valueOfChangeBarChart',
    'resource:solutions.mosaic.widgets.changeImpacts.valueOfChangeByEpic',
    'resource:solutions.mosaic.widgets.changeImpacts.valueOfChangeByFunctionalArea',
  ],
  description:
    'A package containing entities and resources specific to the Ascend Change Impacts application.',
  name: 'Ascend Change Impacts',
} as const satisfies core.quiver.Package
